import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api'
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;

// ماه‌های افغانی (شمسی)
export const AFGHAN_MONTHS = [
  'حمل', 'ثور', 'جوزا', 'سرطان', 'اسد', 'سنبله',
  'میزان', 'عقرب', 'قوس', 'جدی', 'دلو', 'حوت'
];

// تبدیل تاریخ میلادی به شمسی ساده
export function toShamsi(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  // تبدیل تقریبی
  const year = d.getFullYear() - 621;
  const month = d.getMonth();
  const day = d.getDate();
  return `${day} ${AFGHAN_MONTHS[month]} ${year}`;
}

// فرمت پول افغانی
export function formatMoney(amount) {
  if (!amount) return '۰ افغانی';
  return new Intl.NumberFormat('fa-AF').format(amount) + ' ؋';
}

export const EXPENSE_CATEGORIES = [
  'حمل و نقل', 'خوراک', 'صحی', 'لباس', 'برق و آب', 'کرایه', 'تعلیم', 'سایر'
];
